module.exports = __webpack_public_path__ + "static/media/lottery5_banner_MHSBGREEN.cfec36b8.png";